export default {
  request: (msg, callback) => {
    if (confirm(msg)) {
      return callback()
    } else {
      return true
    }
  }
}
